import { render, staticRenderFns } from "./CistePlatforme.vue?vue&type=template&id=5896b1dc&"
import script from "./CistePlatforme.vue?vue&type=script&lang=js&"
export * from "./CistePlatforme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports